<template>
  <!-- CONTENT -->
  <div
    :id="'screen'"
    :style="{opacity: opacity}"
  >
    <Background />

    <Header
      :title="'New password'"
      :showGoBack="true"
    />
    <main class="scrollable container">
      <section :style="{marginTop: '20px', marginBottom: '20px'}">
        <p
          class="t16"
          :style="{marginBottom: '30px'}"
        >
          Enter new password and confirm.
        </p>
        <Input
          :leftIcon="KeySvg"
          :rightIcon="EyeOffSvg"
          :rightIconClickable="true"
          :containerStyle="{marginBottom: '10px'}"
        />
        <Input
          :leftIcon="KeySvg"
          :rightIcon="EyeOffSvg"
          :rightIconClickable="true"
          :containerStyle="{marginBottom: '30px'}"
        />
        <Button
          :title="'Change Password'"
          :onClick="() => $router.push('/forgot-password-sent-email')"
        />
      </section>
    </main>
  </div>
</template>

<script setup>
// hooks
import {useOpacity} from '@/hooks';

// svg
import {KeySvg} from '@/assets/svg';
import {EyeOffSvg} from '@/assets/svg';

// components
import {Button} from '@/components';
import {Header} from '@/components';
import {Input} from '@/components';
import {Background} from '@/components';

// other
const opacity = useOpacity();
</script>
